export default {

  bills: (state) => {
    return state.bills;
  },

  parts: (state) => {
    return state.parts;
  },

  loans: (state) => {
    return state.loans;
  },

  rewards: (state) => {
    return state.rewards;
  },

};
